import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import LocalFilePicker from "../components/associatedFiles/LocalFilePicker";
import AsyncLoadingButton from "../components/asyncLoadingButton/AsyncLoadingButton";

interface Props {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly onNewFile: (formData: FormData) => void | Promise<void>;
}

export const AddImageDialog: FC<Props> = ({ open, onClose, onNewFile }) => {
  const [file, setFile] = useState<File | undefined>(undefined);

  const handleChangeFile = (file: File) => {
    setFile(file);
  };

  const handleAdd = async () => {
    if (!file) {
      return;
    }
    const formData = new FormData();
    formData.append("file", file, file.name);
    await onNewFile(formData);
    onClose();
  };

  const addEnabled = !!file;
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Dodaj grafikę</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            marginTop: 1,
          }}
        >
          <LocalFilePicker label="Plik graficzny" accept="image/*" onFileChange={handleChangeFile} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          Anuluj
        </Button>
        <AsyncLoadingButton color="primary" disabled={!addEnabled} onClick={handleAdd}>
          Dodaj
        </AsyncLoadingButton>
      </DialogActions>
    </Dialog>
  );
};
